import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";
import { ICreditMemo } from "redux/reducers/models/creditMemo";

interface IGetCreditMemo {
    id?: number;
    vendor_id?: number;
    status?: "draft" | "finalized";
    statuses?: Array<string>;
    extended?: boolean;
    search?: string;
    offset?: number;
    limit?: number;
    year?: number;
}

interface IPostCreditMemo {
    vendor_id: number | null;
    purchase_order_id: number;

    status: string;
    source?: "receiving_shortfall" | null;
    credit_memo_number: string;

    facility_name: string;
    facility_address_line: string;
    facility_city: string;
    facility_province: string;
    facility_postal: string;
    facility_country: string;

    // Vendor
    vendor_name: string;
    vendor_address_line: string;
    vendor_city: string;
    vendor_province: string;
    vendor_postal: string;
    vendor_country: string;
    vendor_contact_name: string | null;
    vendor_email: string | null;
    vendor_phone: string | null;

    notes: string | null;
}

interface IPutCreditOrder {
    id: number;
    vendor_id?: number | null;
    purchase_order_id?: number;

    status?: string;
    po_number?: string;

    facility_name?: string;
    facility_address_line?: string;
    facility_city?: string;
    facility_province?: string;
    facility_postal?: string;
    facility_country?: string;

    // Vendor
    vendor_name?: string;
    vendor_address_line?: string;
    vendor_city?: string;
    vendor_province?: string;
    vendor_postal?: string;
    vendor_country?: string;
    vendor_contact_name?: string | null;
    vendor_email?: string | null;
    vendor_phone?: string | null;

    notes?: string | null;
}

// Credit memo
export async function GetCreditMemo(params: IGetCreditMemo, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet<Array<ICreditMemo>>(APIUrl(AdminType.FacilityAdmin, "/credit-memo"), params, useGlobalLoader, token);
}

export async function PostCreditMemo(params: IPostCreditMemo, useGlobalLoader: boolean) {
    return await APIPost<ICreditMemo>(APIUrl(AdminType.FacilityAdmin, "/credit-memo"), params, useGlobalLoader);
}

export async function PutCreditMemo(params: IPutCreditOrder, useGlobalLoader: boolean) {
    return await APIPut<ICreditMemo>(APIUrl(AdminType.FacilityAdmin, "/credit-memo"), params, useGlobalLoader);
}

export async function PutCreditMemoFinalize(params: {id: number; inventory_effect: "adjust" | "unsellable" | "none"}, useGlobalLoader: boolean) {
    return await APIPut<ICreditMemo>(APIUrl(AdminType.FacilityAdmin, "/credit-memo/finalize"), params, useGlobalLoader);
}

export async function DeleteCreditMemo(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/credit-memo"), params, useGlobalLoader);
}

export async function GetCreditMemoDownload(params: {id: number}, useGlobalLoader: boolean) {
    return await APIGet(APIUrl(AdminType.FacilityAdmin, "/credit-memo/download"), params, useGlobalLoader);
}

// // Credit memo items
export async function PostCreditMemoItems(params: {credit_memo_id: number; variants: Array<{variant_id: number; quantity: number; unit_cost: number; notes?: number;}>}, useGlobalLoader: boolean) {
    return await APIPost<ICreditMemo>(APIUrl(AdminType.FacilityAdmin, "/credit-memo/item"), params, useGlobalLoader);
}

export async function PutCreditMemoItems(params: {credit_memo_id: number; items: Array<{id: number; quantity: number; unit_cost: number; notes?: string;}>}, useGlobalLoader: boolean) {
    return await APIPut<ICreditMemo>(APIUrl(AdminType.FacilityAdmin, "/credit-memo/item"), params, useGlobalLoader);
}

export async function DeleteCreditMemoItem(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete<ICreditMemo>(APIUrl(AdminType.FacilityAdmin, "/credit-memo/item"), params, useGlobalLoader);
}